import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { FormInfo, ResponseInfo } from 'src/app/models/models';
import { GetEmpty } from 'src/app/classes/Empties';
import { FormOptions } from 'src/app/classes/FormOptions';
import { Question, User } from 'src/app/models/RestModels';
import { mergeMap } from 'rxjs/operators';
import { ParamMap } from '@angular/router';
import { forkJoin, of } from 'rxjs';

@Component({
	selector: 'app-save-response',
	templateUrl: './save-response.component.html',
	styleUrls: ['./save-response.component.css']
})
export class SaveResponseComponent extends BaseComponent implements OnInit
{

	response_info: ResponseInfo = GetEmpty.response_info(0);
	user_id: number | null = null;
	user_list:User[] = [];

	change_user_enabled: boolean = true;

	//Opciones marcadas de las preguntas checkbox, por indice dentro de answers.
	checkbox_selected:{[index:number]:string[]} = {};


	ngOnInit(): void {

		this.subs.sink = this.route.paramMap
		.pipe
		(
			mergeMap((paramMap: ParamMap) =>
			{
				this.is_loading = true;

				if (paramMap.has('user_id'))
				{
					this.user_id = parseInt(paramMap.get('user_id'));
					this.change_user_enabled = false;
				}

				if (paramMap.has('id'))
				{
					this.change_user_enabled = false;
					return forkJoin({
						response_info: this.rest.response_info.get(paramMap.get('id')),
						users: this.rest.user.search({ eq:{status: 'ACTIVE'}	,limit:99999})
					})
				}

				if (!this.user_id)
				{
					this.change_user_enabled = true;
				}

				return this.rest.form_info.get(paramMap.get('form_id'))
				.pipe
				(
					mergeMap((form_info: FormInfo) =>
					{
						let tmp_response_info = GetEmpty.response_info(form_info.form.id);

						tmp_response_info.response.form_id = form_info.form.id;

						tmp_response_info.form = form_info.form;

						tmp_response_info.answers = form_info.questions
						.map((question) =>
						{
							let answer = GetEmpty.answer();
							answer.question_id = question.id;

							return {question,answer};
						});

						return forkJoin
						({
							response_info: of(tmp_response_info),
							users: this.rest.user.search({ eq:{status: 'ACTIVE'}	,limit:99999})
						});
					}),
					mergeMap((response) =>
					{
						if (this.user_id)
						{
							response.response_info.response.user_id = this.user_id;

							let user = response.users.data.find((user) => user.id == this.user_id);
							if (user)
							{
								response.response_info.user = user;
							}
						}

						return forkJoin({
							response_info: of(response.response_info),
							users: of(response.users)
						});
					})
				)
			}),
		)
		.subscribe
		({
			next: (result) =>
			{
				this.is_loading = false;
				this.response_info = result.response_info;
				this.sortAnswers();
				this.initCheckboxState();
				this.user_list = result.users.data;
			},
			error: (error) =>
			{
				this.showError(error);
			}
		});
	}

	sortAnswers()
	{
		this.response_info.answers.sort((a,b) => b.question.priority - a.question.priority);
	}

	isOptionType(question:Question):boolean
	{
		return FormOptions.isOptionType(question);
	}

	getOptions(question:Question):string[]
	{
		return FormOptions.parseOptions(question);
	}

	isLabel(question:Question):boolean
	{
		return FormOptions.isLabel(question);
	}

	getInputType(type:string):string
	{
		switch( type )
		{
			case 'number': return 'number';
			case 'date': return 'date';
			case 'tel': return 'tel';
			default: return 'text';
		}
	}

	//Reconstruye el estado de los checkboxes desde answer_text (arreglo JSON).
	initCheckboxState()
	{
		this.checkbox_selected = {};

		this.response_info.answers.forEach((ai, i)=>
		{
			if( FormOptions.isCheckbox(ai.question) )
				this.checkbox_selected[i] = FormOptions.parseCheckboxAnswer(ai.answer?.answer_text);
		});
	}

	isChecked(index:number, option:string):boolean
	{
		return (this.checkbox_selected[index] || []).indexOf(option) >= 0;
	}

	toggleCheckbox(index:number, option:string, evt:Event)
	{
		let checked = (evt.target as HTMLInputElement).checked;
		let selected = (this.checkbox_selected[index] || []).slice();

		if( checked && selected.indexOf(option) < 0 )
			selected.push(option);

		if( !checked )
			selected = selected.filter((o)=>o != option);

		this.checkbox_selected[index] = selected;
		this.response_info.answers[index].answer.answer_text = FormOptions.encodeCheckboxAnswer(selected);
	}

	changeResponseUser(user: User)
	{
		if (!user)
		{
			this.response_info.response.user_id = null;
			this.response_info.user = null;
			return;
		}
		this.response_info.response.user_id = user.id;
		this.response_info.user = user;
	}

	save(evt: Event)
	{
		evt.preventDefault();

		//ngNativeValidate no cubre radio/checkbox de opciones: validar aca.
		let empty_required = this.response_info.answers.find((ai)=>
			ai.question.required == 1 && !FormOptions.isAnswered(ai.question, ai.answer?.answer_text)
		);

		if( empty_required )
		{
			this.showError('La pregunta "'+empty_required.question.question+'" es obligatoria');
			return;
		}

		this.is_loading = true;

		if(this.response_info.response.id != 0)
		{
			this.subs.sink = this.rest.response_info.update(this.response_info)
			.subscribe
			({
				next: (response) =>
				{
					this.is_loading = false;
					this.showSuccess('Respuesta actualizada');
					this.location.back();
				},
				error: (error) =>
				{
					this.is_loading = false;
					this.showError(error);
				}
			});
			return;
		}

		this.subs.sink = this.rest.response_info.create(this.response_info)
		.subscribe
		({
			next: (response) =>
			{
				this.is_loading = false;
				this.showSuccess('Respuesta creada');
				this.location.back();
			},
			error: (error) =>
			{
				this.is_loading = false;
				this.showError(error);
			}
		});
	}
}
